import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty, throwError, of } from 'rxjs';
import {
  IAddQuoteBody, IAddQuoteItemToCartItemListBody, IAddQuoteToCartBody, ICopyQuoteRequestBody,
  ICreateQuoteItemRevisionBody, IEmptyQuoteItemsBody, IInhouseQuote,
  IPrintMaterialProposalBody, IQuote, IQuoteDetailPayload, IRequestAFactoryQuoteBody,
  IRequestAFactoryQuotePayload, IRequestAQuoteBody, IRequestAQuotePayload,
  IGetKdQuoteDetailBody, IUser, Quote, IAddItemToKdQuoteItemListBody, QuoteItem,
  IDeleteKdQuoteItemBody,
  IQuoteItem,
  IUpdateQuoteBody,
  IDeleteKdQuoteBody,
  IAddQuoteItemToCartResult,
  IAddQuoteToCartResult,
  IUpdateItemToQuoteBody,
  IAddCartToQuoteBody, BaseResponse, IGetQuoteBody, IModifyQuoteResponse
} from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { tap, map, catchError } from 'rxjs/operators';
/*import { isQuote } from '@angular/compiler';*/
import { UserService } from './user.service';
import { result } from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {
  //#region constructor & Members
  constructor(private httpClient: HttpClient, private userService: UserService) { }

  //public get readUserObject(): IUser {
  //  return JSON.parse(localStorage.getItem('kdLogin')) as IUser;
  //}

  //#endregion
  //#region  Api endPoints
  //#region KD quotes
  //#region variable & properties
  private KD_QUOTE: Array<IQuote> = [];
  private KD_LOCKED_QUOTEID: Array<string> = [];
  private localStorageLockQuoteKey: string = "KDQuoteLockData";
  public get kdQuote(): Array<Quote> {
    if (!this.KD_QUOTE) {
      this.KD_QUOTE = [];
    }
    return this.KD_QUOTE;
  }

  public set kdQuote(kdQuotes: Array<Quote>) {
    this.KD_QUOTE = kdQuotes;
  }
  //#endregion
  //#region support methods
  //#endergion
  //#region api calls
  //#endregion

  public getKdQuotes(body: IGetQuoteBody): Observable<Array<IQuote>> {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.GET_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data),
        tap((kdQuotes) => {
          this.KD_QUOTE = kdQuotes.map((obj) => {
            obj.quoteDate = new Date(obj.quoteDate);
            obj.expirationDate = new Date(obj.expirationDate);
            return obj;
          })
        }));
  }
  public getKdQuotesWithItemCount(): Observable<Array<IQuote>> {
    const body = {
      customerNumber: this.userService.readUserObject.customerNumber,
      //userId: this.userService.readUserObject.userId
    }
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.GET_KD_QUOTE_WITH_ITEM_COUNT}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public getUserForTransferQuote(quoteCommonId: string): Observable<any> {

    const apiEndpoint = `${ConfigService.APIs.endPoints.QUOTE.GET_USER_FOR_TRANSFER_QUOTE}/${quoteCommonId}`;
    console.log('API Endpoint:', apiEndpoint);
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint)
      .pipe(
        map((response: any) => response),
        catchError((err) => {
          console.error(err);
          return of([]);
        })
      );
  }
  public updateQuoteUser(payload: any) {

    const apiEndpoint =
      `${ConfigService.APIs.endPoints.QUOTE.UPDATE_QUOTE_USER}`;

    return ApiService.genericObservablePost(
      this.httpClient,
      apiEndpoint,
      payload
    );
  }
  public updateKdQuoteStatus(body: IQuote): Observable<IQuote> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.UPDATE_KD_QUOTE_STATUS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((kdQuote) => this.updateKDQuoteLocal(kdQuote))
      );
  }
  public getKdQuoteDetail(body: IGetKdQuoteDetailBody): Observable<Array<QuoteItem>> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.GET_KD_QUOTE_DETAIL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data),
        tap((kdQuoteItems) => { this.kdQuoteItems = kdQuoteItems })
      );
  }
  public GetQuotePromoCodeFee(customerNumber: string, promoCode, quoteCommonId) {
    const apiEndpoint = ConfigService.APIs.endPoints.QUOTE.GET_QUOTE_PROMO_CODE_FEE;
    const userRaw = localStorage.getItem('user');
    let userObj: any = null;
    try {
      userObj = userRaw ? JSON.parse(userRaw) : null;
    } catch {
      userObj = null;
    }

    const userName = (userObj && userObj.userName) ? userObj.userName : '';

    const body = {
      customerNumber: customerNumber,
      promoCode: promoCode,
      quoteCommonId: quoteCommonId,
      languageCode: localStorage.getItem('language')
    };

    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: any) => {
        if (response && response.data) {
          return response.data
        }
        return null;
      })
    ) as Observable<{
      userId: string
      code: string
      discount: string
      discountType: string
      savingperItem: string
      newPricePerItem: string
      applicablePromoCode: string
      freeFreight: string
      oneTime: string
      methodType: string
      cartItemCommonId: string
      quoteCommonId: string
      longItemNumber: string
      itemNumber: string
      totalDiscount: string
    } | null>;
  }

  public getQuoteMinimumOrderFees(quoteCommonId: string) {
    const apiEndpoint = ConfigService.APIs.endPoints.QUOTE.GET_QUOTE_MIN_ORDER_FEE;

    const userObj = this.userService.readUserObject;
    const custNumber = userObj ? userObj.customerNumber : '';
    const userName = (userObj && userObj.userName) ? userObj.userName : '';

    const body = {
      quoteCommonId: quoteCommonId,
      customerNumber: custNumber
    };

    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: any) => {
        if (response && response.data) {
          return {
            minApplicableOrderFee: response.data.minApplicableOrderFee,
            orderFeesMessageEng: response.data.orderFeesMessageEng,
            orderFeesMessageFre: response.data.orderFeesMessageFre
          };
        }
        return null;
      })
    ) as Observable<{
      minApplicableOrderFee: number;
      orderFeesMessageEng: string;
      orderFeesMessageFre: string;
    } | null>;
  }
  public add(body: IAddQuoteBody): Observable<Array<IQuote>> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public createConfigureProductQuote(body: any): Observable<Array<IQuote>> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.CREATE_CONFIGURE_PRODUCT_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public addConfiguredItemToQuote(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_CONFIGURED_ITEM_TO_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public addQuoteToCart(body: IAddQuoteToCartBody): Observable<IAddQuoteToCartResult> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_QUOTE_TO_CART}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  public addQuoteItemToCartItemList(body: IAddQuoteItemToCartItemListBody): Observable<IAddQuoteItemToCartResult> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_QUOTE_ITEM_TO_CART_ITEM_LIST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  public deleteKdQuote(body: IDeleteKdQuoteBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.DELETE_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data),
        tap((response) => { this.removeKDQuote = body.quoteCommonId })
      );
  }
  public deleteKdQuoteItem(body: IDeleteKdQuoteItemBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.DELETE_KD_QUOTE_ITEM}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { return response.data; })
    );
  }
  public emptyKdQuoteItems(body: IEmptyQuoteItemsBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.EMPTY_KD_QUOTE_ITEMS}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { return response.data; })
    );
  }
  public copyKdQuote(body: ICopyQuoteRequestBody): Observable<IQuote> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.COPY_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result }),
        tap((kdQuotes) => { this.updateKDQuoteLocal(kdQuotes) })
      );
  }
  public addItemToKdQuoteItemList(body: IAddItemToKdQuoteItemListBody): Observable<IQuoteItem> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_ITEM_TO_KD_QUOTE_ITEM_LIST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((kdQuoteItem: QuoteItem) => { this.addkdQuoteItem = kdQuoteItem })
      );
  }
  //calling this from advance search add to quote popup
  public addItemToKdQuote(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_ITEM_TO_KD_QUOTE_ITEM_LIST}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => {
        return throwError(err);
      }),
      map((response: BaseResponse) => response.data)
    );
  }
  public createQuote(body: any): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.CREATE_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //calling this from cart screen add to quote 
  public addCartItemToKdQuote(body: IAddCartToQuoteBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_Cart_ITEM_TO_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public updateItemToKdQuote(body: IUpdateItemToQuoteBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.UPDATE_ITEM_TO_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
        tap((kdQuoteItem: IModifyQuoteResponse) => { this.updatekdQuoteItem(kdQuoteItem) }));
  }
  public createQuoteItemRevision(body: ICreateQuoteItemRevisionBody): Observable<IQuote> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.CREATE_QUOTE_ITEM_REVISION}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; }),
      tap((kdQuotes) => { this.updateKDQuoteLocal(kdQuotes) })
    );
  }

  public printMaterialProposal(body: IPrintMaterialProposalBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.PRINT_MATERIAL_PROPOSAL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public printInHouseMaterialProposal(body: IPrintMaterialProposalBody): Observable<any> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.PRINT_INHOUSE_MATERIAL_PROPOSAL}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //using this in kd quote details page
  public selectedQuoteHeader: IQuote = new Quote();
  public copyQuoteHeader: IQuote = new Quote();
  public quoteRowData: IQuote = null;
  public setQuote(rowData: IQuote) {
    this.quoteRowData = rowData;
  }
  public getQuoteData() {
    return this.quoteRowData;
  }
  //#endregion

  //#region add new kd quote
  public addKdQuote(body: IAddQuoteBody): Observable<Array<Quote>> {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.ADD_KD_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body)
      .pipe(
        catchError((err, caught) => { return throwError(err); }),
        map((response: BaseResponse) => response.data),
        tap((kdQuote) => {
          console.log(typeof (kdQuote));
          let result: any; result = kdQuote;
          this.AddkdQuote = result;

        })
      );
  }

  //this.KD_QUOTE = kdQuotes.map((obj) => {
  //  obj.quoteDate = new Date(obj.quoteDate);
  //  obj.expirationDate = new Date(obj.expirationDate);
  //  return obj;
  //})
  public updateKdQuoteHeader(body: IUpdateQuoteBody): Observable<Quote> {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.Update_KD_QUOTE_HEADER}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  //#endregion
  public getAllInhouseQuotes(): Observable<Array<IInhouseQuote>> {
    const customerNumber = this.userService.readUserObject.customerNumber;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.GET_ALL_INHOUSE_QUOTES}/${customerNumber}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#region Request quote
  public requestAQuote(body: IRequestAQuoteBody): Observable<any> {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    //body.createdBy = this.userService.readUserObject.userId;
    body.userName = this.userService.readUserObject.userName; //this.userService.readUserObject.userFirstName + " " + this.userService.readUserObject.userLastName;
    body.userEmail = this.userService.readUserObject.email;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.REQUEST_A_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  //#endregion
  //#region Factory Request Quote
  public requestAFactoryQuote(body: IRequestAFactoryQuoteBody): Observable<any> {
    body.customerNumber = this.userService.readUserObject.customerNumber;
    body.customerName = this.userService.readUserObject.customerName;
    body.userName = this.userService.readUserObject.userName;
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.REQUEST_A_FACTORY_QUOTE}`;
    return ApiService.genericObservablePost(this.httpClient, endPoint, body).pipe(
      catchError((err, caught) => { return throwError(err); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public requestAFactoryQuotePayload(): Observable<IRequestAFactoryQuotePayload> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.REQUEST_A_FACTORY_QUOTE_PAYLOAD}`;
    //return ApiService.genericObservableGet(this.httpClient, endPoint)
    return ApiService.genericJSONGet(this.httpClient);
  }
  //#endregion
  public quoteDetailPayload(): Observable<IQuoteDetailPayload> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.QUOTE_DETAIL_PAYLOAD}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }

  public requestAQuotePayload(): Observable<IRequestAQuotePayload> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.REQUEST_A_QUOTE_PAYLOAD}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  private checkQuoteLockStatus(quoteCommonId): Observable<boolean> {
    const endPoint = `${ConfigService.APIs.endPoints.QUOTE.GET_KD_QUOTE_LOCK_STATUS}/${quoteCommonId}`;
    return ApiService.genericObservableGet(this.httpClient, endPoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => { let result: any; result = response.data; return result; })
    );
  }
  //#endregion

  //#region kdquoteItems Cache
  private KD_QUOTE_ITEMS: Array<IQuoteItem> = [];
  private Quote_Has_Error: boolean = false;
  public get KD_Quote_Has_Error(): boolean
  {
    return this.Quote_Has_Error;
  }
  public set KD_Quote_Has_Error(kD_Quote_Has_Error :boolean) {
    this.Quote_Has_Error = kD_Quote_Has_Error;
  }

  public get kdQuoteItems(): Array<IQuoteItem> {
    if (!this.KD_QUOTE_ITEMS) {
      this.KD_QUOTE_ITEMS = [];
    }
    return this.KD_QUOTE_ITEMS;
  }

  public set kdQuoteItems(kdQuoteItems: Array<IQuoteItem>) {
    if (kdQuoteItems) {
      this.KD_QUOTE_ITEMS = kdQuoteItems;
    } else { this.KD_QUOTE_ITEMS = [] }
  }
  public set addkdQuoteItem(kdQuoteItem: IQuoteItem) {
    if (kdQuoteItem) {
      const index = this.kdQuoteItems.findIndex(r => r.longItemNumber === kdQuoteItem.longItemNumber);
      const tempkdQuoteItem = this.kdQuoteItems.find(r => r.longItemNumber === kdQuoteItem.longItemNumber);

      if (tempkdQuoteItem) {
        tempkdQuoteItem.quantity += (+kdQuoteItem.quantity);
        tempkdQuoteItem.extendedPrice = kdQuoteItem.extendedPrice;
        this.KD_QUOTE_ITEMS.splice(index, 1, tempkdQuoteItem);
      } else {
        this.KD_QUOTE_ITEMS.push(kdQuoteItem);
      }
    }
  }

  public updatekdQuoteItem(apiResponse: IModifyQuoteResponse) {
    if (apiResponse.status) {
      let kdQuoteItem: IQuoteItem = apiResponse.items[0];
      if (kdQuoteItem) {
      const index = this.kdQuoteItems
        .findIndex(r => (r.quoteItemCommonId === kdQuoteItem.quoteItemCommonId) && (r.quoteCommonId === kdQuoteItem.quoteCommonId));
      const tempkdQuoteItem = this.kdQuoteItems
        .find(r => (r.quoteItemCommonId === kdQuoteItem.quoteItemCommonId) && (r.quoteCommonId === kdQuoteItem.quoteCommonId));

        if (tempkdQuoteItem) {
          if (kdQuoteItem.quoteItemCommonIdToUpdate && kdQuoteItem.quoteItemCommonIdToUpdate.length > 0) {//update the quoteItemComonId after Delete and add item to servicex
            kdQuoteItem.quoteItemCommonId = kdQuoteItem.quoteItemCommonIdToUpdate;//with new quote commonid
          }
          this.KD_QUOTE_ITEMS.splice(index, 1, kdQuoteItem);
          if (kdQuoteItem.quoteItemCommonIdToDelete && kdQuoteItem.quoteItemCommonIdToDelete.length > 0) {//if any item updated to an existing item then delete the item after 
            this.removekdQuoteItem = kdQuoteItem.quoteItemCommonIdToDelete;//updating the quantity of existing item
          }
        }
      } else {
        this.KD_QUOTE_ITEMS.push(kdQuoteItem);
      }
    }
  }
  public set removekdQuoteItem(quoteItemCommonId: string) {
    if (quoteItemCommonId) {
      const index = this.kdQuoteItems.findIndex(r => r.quoteItemCommonId === quoteItemCommonId);
      const tempkdQuoteItem = this.kdQuoteItems.find(r => r.quoteItemCommonId === quoteItemCommonId);

      if (tempkdQuoteItem) {
        this.KD_QUOTE_ITEMS.splice(index, 1);
      }
    }
  }

  public uploadItems(data: IQuoteItem[]): Observable<any> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.QUOTE.UPLOAD_ITEMS}`;
    //const apiEndpoint = ConfigService.APIs.endPoints.QUOTE.UPLOAD_ITEMS;
    data.forEach(el => {
      //el.userId = this.userService.readUserObject.userId;
      el.customerNumber = this.userService.readUserObject.customerNumber
    })
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint, data).pipe(
      catchError((err, caught) => {
        throw err;
      }),
      map((response: BaseResponse) => response.data)
    ) as Observable<any>;
  }
  //#endregion

  //#region add kd quote cache

  public set AddkdQuote(kdQuote: Quote) {
    if (kdQuote) {
      kdQuote.quoteDate = new Date(kdQuote.quoteDate);
      kdQuote.expirationDate = new Date(kdQuote.expirationDate);
      const index = this.KD_QUOTE.findIndex(r => r.jobNumber == kdQuote.jobNumber);
      const tempkdQuote = this.KD_QUOTE.find(r => r.jobNumber == kdQuote.jobNumber);

      if (tempkdQuote) {
        this.KD_QUOTE.splice(index, 1, tempkdQuote);
      } else {
        this.KD_QUOTE.unshift(kdQuote);
      }
    }
  }
  public set removeKDQuote(quoteCommonId: string) {
    if (quoteCommonId) {
      this.KD_QUOTE = this.KD_QUOTE.filter(el => el.quoteCommonId !== quoteCommonId);
    }
  }
  public updateKDQuoteLocal(kdQuote: IQuote) {
    if (kdQuote) {
      const index = this.kdQuote
        .findIndex(r => (r.quoteCommonId === kdQuote.quoteCommonId) && (r.quoteCommonId === kdQuote.quoteCommonId));
      const tempkdQuote = this.kdQuote
        .find(r => (r.quoteCommonId === kdQuote.quoteCommonId) && (r.quoteCommonId === kdQuote.quoteCommonId));

      if (tempkdQuote) {
        this.KD_QUOTE.splice(index, 1, kdQuote);
      } else {
        this.KD_QUOTE.push(kdQuote);
      }
    }

    //UPDATING QUOTE HEADER DETAIL
    if (kdQuote) {
      this.selectedQuoteHeader = kdQuote;

      if (kdQuote.quoteItems) {
        this.kdQuoteItems = kdQuote.quoteItems;
      } else {
        this.kdQuoteItems = [];
      }
    }
  }

  //#endregion
  //#region formats javascript date to c# date----Need to move to common file
  formatJSDate(date) {
    if (date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('/');
    } else {
      return "";
    }
  }
  //#endregion

  //#region Paint Disclaimer
  private applicablePaintsForDisclaimer = ['379A1455', '379A1456', '379A1451', '379A1453', '379A1457'];
  isDisclaimerMessageOfPaintApplicable(paintCode: string) {
    if (!paintCode) return false;
    const index = this.applicablePaintsForDisclaimer.findIndex(o => o == paintCode);
    if (index > -1) {
      return true;
    } else {
      return false;
    }
  }
  paintDisclaimerMsg: string = "A paint finish you have selected (379A1455, 379A1456, 379A1451, 379A1453, 379A1457) may have color variations from the previous finish offered by Kawneer(789G039, 789G013, 789G036, 789G048, 789G048). Please consult your sales rep or project manager if you have questions.";
  //#endregion

  public lockkdQuote(selectedQuoteId: string) {
    this.readLockQuoteObject();
    this.selectedQuoteHeader.isLocked = true;
    const index = this.KD_LOCKED_QUOTEID.findIndex(r => r === selectedQuoteId);
    if (index < 0) {
      this.KD_LOCKED_QUOTEID.push(selectedQuoteId);
      this.saveLockQuoteObject(this.KD_LOCKED_QUOTEID);
    }
  }
  public unLockkdQuote(selectedQuoteId: string) {
    this.readLockQuoteObject();
    this.selectedQuoteHeader.isLocked = false;
    const index = this.KD_LOCKED_QUOTEID.findIndex(r => r === selectedQuoteId);
    if (index > -1) {
      this.KD_LOCKED_QUOTEID.splice(index);
      this.saveLockQuoteObject(this.KD_LOCKED_QUOTEID);
    }
  }
  public iskdQuoteIsLocked(selectedQuoteId: string) {
    this.readLockQuoteObject();
    const index = this.KD_LOCKED_QUOTEID.findIndex(r => r === selectedQuoteId);
    const idIndex = this.kdQuote.findIndex(r => r.quoteCommonId === selectedQuoteId);
    if (index > -1) {
      this.checkQuoteLockStatus(selectedQuoteId).subscribe((response) => {
        if (response) {
          this.selectedQuoteHeader.isLocked = true;
          if (idIndex > -1) {
            this.kdQuote[idIndex].isLocked = true;
          }
        } else {
          this.selectedQuoteHeader.isLocked = false;
          if (idIndex > -1) {
            this.kdQuote[idIndex].isLocked = false;
          }
          this.unLockkdQuote(selectedQuoteId);
        }
      })
    }
  }
  
  private readLockQuoteObject() {
    this.KD_LOCKED_QUOTEID = JSON.parse(localStorage.getItem(this.localStorageLockQuoteKey)) as string[];
    if (!this.KD_LOCKED_QUOTEID) {
      this.KD_LOCKED_QUOTEID = [];
    }
  }
  private saveLockQuoteObject(lockData: string[]) {
    //to subscribe to the idle session
    if (lockData.length >0) {
      localStorage.setItem(this.localStorageLockQuoteKey, JSON.stringify(lockData));
      //console.log("userSignedIn " + JSON.stringify(login));
    }
  }
}
